import * as types from './types';
import { CALL_API } from '../middleware/api';
export const deleteAllIncomes = (previousIncomes) => ({
    [CALL_API]: {
        endpoint: '/income',
        method: 'DELETE',
        extra: { previousIncomes },
        types: [
            types.DELETE_ALL_INCOMES_REQUEST,
            types.DELETE_ALL_INCOMES_SUCCESS,
            types.DELETE_ALL_INCOMES_FAILURE,
        ],
    },
});
export const setIncome = (incomeBody, previousIncomes) => {
    const body = {
        ...incomeBody,
        isPrimary: true,
        deleteAllPrevious: true,
    };
    return {
        [CALL_API]: {
            endpoint: '/incomes',
            method: 'POST',
            body: JSON.stringify(body),
            extra: { body, previousIncomes },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                types.SET_INCOME_REQUEST,
                types.SET_INCOME_SUCCESS,
                types.SET_INCOME_FAILURE,
            ],
        },
    };
};
export const getIncomes = () => ({
    [CALL_API]: {
        endpoint: '/incomes',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.GET_INCOME_REQUEST,
            types.GET_INCOME_SUCCESS,
            types.GET_INCOME_FAILURE,
        ],
    },
});
